export default __webpack_public_path__ + "static/media/nightsky.28fd4f2b.jpg";